import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as authSelectors from "redux/auth/selectors";
import useQueryParam from "hooks/useQueryParam";
import { getLocalStorageItem } from "utils/localStorage";
import { STORAGE_AUTH_TOKEN } from "constants/variables";
import { userApi } from "redux/user/api";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useAuthStore } from "stores/auth";
import { authApi } from "redux/auth/api";

export const useCheckToken = () => {
  const navigate = useNavigate();
  const token = getLocalStorageItem(STORAGE_AUTH_TOKEN);
  const authToken = useQueryParam("autologin");
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const [signIn] = authApi.useLoginMutation();
  const { refetch } = userApi.useGetProfileQuery(token ? "" : skipToken);
  const setIsAfterAuthCheck = useAuthStore(
    (state) => state.setIsAfterAuthCheck,
  );

  const isAuthCheck = useAuthStore((state) => state.isAfterAuthCheck);

  useEffect(() => {
    if (token) {
      refetch();
    } else {
      setTimeout(() => {
        setIsAfterAuthCheck(true);
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const loginQueryTokenParams = async () => {
      if (!isAuthCheck) {
        return;
      }

      if (isAuthCheck && isAuthenticated) {
        return;
      }

      if (authToken && authToken.length > 0) {
        await signIn({
          authToken: authToken.replace(/\s/g, "+"),
          authType: "email",
        });
      }
    };

    if (authToken) {
      if (!isAuthenticated) {
        loginQueryTokenParams();
      } else {
        navigate("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, isAuthenticated, navigate, signIn, isAuthCheck]);

  return null;
};
